// import React, { useState, useEffect } from 'react';
// import { Share2, Play, Info, ArrowRight, RotateCcw, XCircle, CheckCircle2, Zap } from 'lucide-react';
// import questionsData from './questions';

// const { questions } = questionsData;

// // --- IMAGE LOADER ---
// // Ensure 'src/touching-images' exists.
// let touchingImages = [];
// try {
//   const r = require.context('./touching-images', false, /\.(png|jpe?g|svg|webp)$/);
//   touchingImages = r.keys().map(r);
// } catch (e) {
//   console.log("Error loading images. Ensure 'src/touching-images' exists.");
// }

// // --- OPTIMIZED COMPONENT START ---
// const BackgroundMontage = ({ touchingImages = [] }) => {
//   // 1. CONSTANTS
//   const DISPLAY_DURATION = 750; 
//   const TRANSITION_DURATION = 125; 

//   // 2. HOOKS (Must always run unconditionally)
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isLoaded, setIsLoaded] = useState(false);

//   // Helper to check validity inside hooks
//   const hasImages = touchingImages && touchingImages.length > 0;

//   // 3. JIT PRELOADING
//   useEffect(() => {
//     if (!hasImages) return;
//     const nextIndex = (currentIndex + 1) % touchingImages.length;
//     const img = new Image();
//     img.src = touchingImages[nextIndex];
    
//     // Optional: Preload buffer
//     const nextNextIndex = (currentIndex + 2) % touchingImages.length;
//     const img2 = new Image();
//     img2.src = touchingImages[nextNextIndex];
//   }, [currentIndex, hasImages, touchingImages]);

//   // 4. INITIAL LOAD HANDLER
//   useEffect(() => {
//     if (!hasImages) return;
//     const img = new Image();
//     img.src = touchingImages[0];
//     img.onload = () => setIsLoaded(true);
//     img.onerror = () => setIsLoaded(true);
//   }, [hasImages, touchingImages]);

//   // 5. THE CLOCK
//   useEffect(() => {
//     if (!isLoaded || !hasImages) return;
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % touchingImages.length);
//     }, DISPLAY_DURATION);
//     return () => clearInterval(interval);
//   }, [isLoaded, hasImages, touchingImages, DISPLAY_DURATION]);

//   // 6. EARLY RETURNS (Safe now because hooks are done)
//   if (!hasImages) return null;
//   if (!isLoaded) return null;

//   // 7. PING-PONG RENDER LOGIC
//   const activeIndex = currentIndex % 2; // 0 or 1
//   const prevIndex = currentIndex === 0 ? touchingImages.length - 1 : currentIndex - 1;

//   // Determine which image goes in Slot A vs Slot B
//   const srcA = activeIndex === 0 ? touchingImages[currentIndex] : touchingImages[prevIndex];
//   const srcB = activeIndex === 1 ? touchingImages[currentIndex] : touchingImages[prevIndex];

//   return (
//     <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none bg-[#1e1e24] select-none">
//       {/* Static Overlay */}
//       <div className="absolute inset-0 bg-[#1e1e24]/60 z-20 backdrop-blur-[2px] will-change-transform" />

//       {/* SLOT A: Handles Even Indices */}
//       <img
//         src={srcA}
//         alt=""
//         decoding="async"
//         className="absolute inset-0 w-full h-full object-cover will-change-opacity transition-opacity ease-in-out z-10"
//         style={{
//           transitionDuration: `${TRANSITION_DURATION}ms`,
//           opacity: activeIndex === 0 ? 1 : 0,
//           filter: 'saturate(200%)',
//           transform: 'translate3d(0, 0, 0)', // Force GPU layer
//         }}
//       />

//       {/* SLOT B: Handles Odd Indices */}
//       <img
//         src={srcB}
//         alt=""
//         decoding="async"
//         className="absolute inset-0 w-full h-full object-cover will-change-opacity transition-opacity ease-in-out z-10"
//         style={{
//           transitionDuration: `${TRANSITION_DURATION}ms`,
//           opacity: activeIndex === 1 ? 1 : 0,
//           filter: 'saturate(200%)',
//           transform: 'translate3d(0, 0, 0)', // Force GPU layer
//         }}
//       />
//     </div>
//   );
// };
// // --- OPTIMIZED COMPONENT END ---


// const GlassCard = ({ children, className = "" }) => (
//   <div className={`
//     relative backdrop-blur-2xl 
//     bg-gradient-to-b from-white/10 to-white/5 
//     border border-white/20 
//     shadow-[0_8px_32px_0_rgba(0,0,0,0.36)] 
//     rounded-3xl 
//     ${className}
//   `}>
//     <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/20 pointer-events-none" />
//     {children}
//   </div>
// );

// const GlassButton = ({ onClick, children, className = "", variant = 'default' }) => {
//   const variants = {
//     default: "bg-white/5 hover:bg-white/10 border-white/10 text-white",
//     primary: "bg-indigo-500 text-white hover:bg-indigo-400 border-transparent shadow-lg shadow-indigo-500/25 font-bold",
//     danger: "bg-red-500/20 text-red-100 border-red-500/30 hover:bg-red-500/30"
//   };

//   return (
//     <button
//       onClick={onClick}
//       className={`
//         relative group overflow-hidden
//         backdrop-blur-md border rounded-2xl p-4
//         transition-all duration-300 ease-out
//         active:scale-[0.98]
//         font-medium tracking-wide
//         flex items-center justify-center gap-3
//         ${variants[variant]}
//         ${className}
//       `}
//     >
//       {children}
//     </button>
//   );
// };

// function App() {
//   const [gameState, setGameState] = useState('menu');
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [score, setScore] = useState(0);
//   const [showExplanation, setShowExplanation] = useState(false);
//   const [selectedAnswer, setSelectedAnswer] = useState(null);
//   const [isCorrect, setIsCorrect] = useState(false);
//   const [usedQuestions, setUsedQuestions] = useState([]);
//   const [highScore, setHighScore] = useState(0);

//   useEffect(() => {
//     const saved = localStorage.getItem('impossibleQuizHighScore');
//     if (saved) setHighScore(parseInt(saved));
//   }, []);

//   function startGame() {
//     const shuffled = [...questions].sort(() => Math.random() - 0.5);
//     setUsedQuestions(shuffled);
//     setCurrentQuestionIndex(0);
//     setScore(0);
//     setShowExplanation(false);
//     setSelectedAnswer(null);
//     setGameState('playing');
//   }

//   function handleAnswer(answerIndex) {
//     const currentQ = usedQuestions[currentQuestionIndex];
//     setSelectedAnswer(answerIndex);
//     const correct = answerIndex === currentQ.correctAnswer;
//     setIsCorrect(correct);
//     setShowExplanation(true);
//     if (correct) setScore(prev => prev + 10);
//   }

//   function handleNextStep() {
//     if (isCorrect) {
//       if (currentQuestionIndex + 1 < usedQuestions.length) {
//         setCurrentQuestionIndex(prev => prev + 1);
//         setShowExplanation(false);
//         setSelectedAnswer(null);
//       } else {
//         endGame(score);
//       }
//     } else {
//       endGame(score);
//     }
//   }

//   function endGame(finalScore) {
//     if (finalScore > highScore) {
//       setHighScore(finalScore);
//       localStorage.setItem('impossibleQuizHighScore', finalScore.toString());
//     }
//     setGameState('gameover');
//   }

//   function shareScore() {
//     const text = `I scored ${score} points on the AI Spotter Assessment. 🧠`;
//     const url = window.location.href;
//     window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
//   }

//   const currentQuestion = usedQuestions[currentQuestionIndex];
//   const hasImages = currentQuestion?.images && currentQuestion.images.length > 0;
//   const imageCount = hasImages ? currentQuestion.images.length : 0;

//   return (
//     <div className="min-h-screen bg-[#1e1e24] font-sans text-white overflow-x-hidden relative selection:bg-purple-500 selection:text-white">
      
//       {/* Background Blobs (Behind Montage) */}
//       <div className="fixed inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-[-20%] left-[20%] w-[40vw] h-[40vw] bg-indigo-500/20 rounded-full blur-[100px]" />
//         <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-indigo-500/10 rounded-full blur-[100px]" />
//       </div>

//       {/* Video Montage (Only in Menu) */}
//       {/* NOTE: We now explicitly pass the global variable as a prop */}
//       {gameState === 'menu' && <BackgroundMontage touchingImages={touchingImages} />}

//       <div className="relative z-10 min-h-screen flex flex-col justify-center items-center p-4 md:p-6">

//         {/* MENU STATE */}
//         {gameState === 'menu' && (
//           <div className="w-full max-w-md animate-in fade-in zoom-in duration-700">
//             <div className="text-center mb-12 space-y-4">
//               <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium uppercase tracking-widest text-white/50 backdrop-blur-sm">
//                 <Zap size={12} className="fill-white/50" />
//                 Turing Test v2.0
//               </div>
//               <h1 className="text-6xl md:text-7xl font-bold tracking-tighter bg-gradient-to-br from-white via-white to-white/40 bg-clip-text text-transparent">
//                 Real or AI?
//               </h1>
//               <p className="text-white/60 font-light text-lg">
//                 Can you distinguish soul from synthetic imitation? <br /> Are you a valid human?
//               </p>
//             </div>
            
//             <GlassCard className="p-2 space-y-2">
//               <GlassButton onClick={startGame} variant="primary" className="w-full h-14 text-lg">
//                 <Play size={20} fill="currentColor" /> Start Assessment
//               </GlassButton>
              
//               <GlassButton onClick={() => setGameState('instructions')} className="w-full h-14 text-lg text-white/70">
//                 <Info size={20} /> Protocol
//               </GlassButton>
//             </GlassCard>

//             {highScore > 0 && (
//               <div className="mt-8 text-center animate-in fade-in slide-in-from-bottom-4 delay-200">
//                   <span className="text-white/40 text-sm font-medium uppercase tracking-widest">
//                     Best Score: <span className="text-white ml-1">{highScore}</span>
//                   </span>
//               </div>
//             )}
//           </div>
//         )}

//         {/* INSTRUCTIONS STATE */}
//         {gameState === 'instructions' && (
//           <GlassCard className="max-w-xl w-full p-8 animate-in fade-in slide-in-from-bottom-8 duration-500">
//             <h2 className="text-2xl font-bold mb-6 tracking-tight">Directives</h2>
//             <div className="grid gap-4 mb-8">
//               {[
//                 { icon: "👁️", text: "Analyze the media provided." },
//                 { icon: "⚖️", text: "Compare images if multiple are present." },
//                 { icon: "💎", text: "+10 Points for correct detection." },
//                 { icon: "💀", text: "One error terminates the session." },
//               ].map((item, i) => (
//                 <div key={i} className="flex items-center gap-4 p-4 rounded-xl bg-white/5 border border-white/5">
//                   <span className="text-xl">{item.icon}</span>
//                   <span className="text-base font-light text-white/80">{item.text}</span>
//                 </div>
//               ))}
//             </div>
//             <GlassButton onClick={() => setGameState('menu')} className="w-full h-12">
//               Back
//             </GlassButton>
//           </GlassCard>
//         )}

//         {/* PLAYING STATE */}
//         {gameState === 'playing' && currentQuestion && (
//           <div className="w-full max-w-7xl mx-auto animate-in fade-in duration-500 pb-6">
            
//             {/* Header Stats */}
//             <div className="flex justify-between items-end mb-4 px-2">
//               <div className="flex flex-col">
//                 <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest mb-0.5">Case File</span>
//                 <span className="text-lg font-light text-white/90">
//                   {String(currentQuestionIndex + 1).padStart(2, '0')} <span className="text-white/30">/ {usedQuestions.length}</span>
//                 </span>
//               </div>
//               <div className="flex flex-col items-end">
//                   <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest mb-0.5">Score</span>
//                   <span className="text-lg font-mono text-white/90">{String(score).padStart(3, '0')}</span>
//               </div>
//             </div>

//             {/* MAIN CONTENT GRID */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              
//               {/* LEFT COLUMN: THE PROMPT */}
//               <div className="h-full">
//                 {hasImages ? (
//                   <GlassCard className="relative overflow-hidden flex items-center justify-center bg-black/20 p-0 lg:h-[600px] min-h-[350px]">
//                       <div className={`w-full h-full p-4 grid gap-4 ${imageCount > 1 ? 'grid-cols-2' : 'grid-cols-1'} items-center justify-items-center`}>
//                       {currentQuestion.images.map((img, idx) => (
//                         <div key={idx} className="relative w-full h-full flex items-center justify-center">
//                             <img 
//                               src={img} 
//                               alt={`Subject ${idx+1}`}
//                               className={`max-w-full h-auto rounded-lg shadow-2xl object-contain ${imageCount === 1 ? 'max-h-[450px]' : 'max-h-full'}`}
//                             />
//                             {imageCount > 1 && (
//                               <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-black/60 backdrop-blur-md rounded-full border border-white/10 text-[10px] font-bold text-white/80">
//                                 {idx === 0 ? 'IMAGE A' : 'IMAGE B'}
//                               </div>
//                             )}
//                         </div>
//                       ))}
//                     </div>
//                     <div className="absolute top-4 left-4 px-2 py-1 bg-black/50 backdrop-blur-md rounded border border-white/10 text-[10px] uppercase tracking-wider text-white/60 pointer-events-none">
//                       Visual Evidence
//                     </div>
//                   </GlassCard>
//                 ) : (
//                   <GlassCard className="h-full flex flex-col justify-center p-8 lg:p-12 min-h-[300px] lg:min-h-[600px]">
//                     <div className="mb-6 inline-flex self-start px-3 py-1 rounded-full bg-white/10 border border-white/10 text-xs font-medium uppercase tracking-widest text-white/60">
//                       {currentQuestion.category || "Text Analysis"}
//                     </div>
//                     <h3 className="text-3xl lg:text-5xl font-medium leading-tight text-white tracking-tight">
//                       {currentQuestion.question}
//                     </h3>
//                     <div className="mt-8 flex items-center gap-3 text-white/40 text-sm">
//                       <div className="h-[1px] w-12 bg-white/20"></div>
//                       <span className="uppercase tracking-widest">Select the human response</span>
//                     </div>
//                   </GlassCard>
//                 )}
//               </div>

//               {/* RIGHT COLUMN: THE OPTIONS */}
//               <div className="flex flex-col justify-center h-full">
                
//                 {hasImages && (
//                   <div className="mb-6 px-2">
//                       <h3 className="text-2xl lg:text-3xl font-medium text-white/95 leading-tight">
//                         {currentQuestion.question}
//                       </h3>
//                   </div>
//                 )}

//                 <div className="space-y-3 w-full">
//                   {!showExplanation ? (
//                     <div className="grid grid-cols-1 gap-3">
//                       {currentQuestion.options.map((option, index) => (
//                         <button
//                           key={index}
//                           onClick={() => handleAnswer(index)}
//                           className="
//                             group relative w-full text-left p-6 rounded-2xl
//                             backdrop-blur-xl bg-white/5 border border-white/10
//                             hover:bg-white/10 hover:border-white/20 hover:scale-[1.01]
//                             active:scale-[0.99]
//                             transition-all duration-200
//                           "
//                         >
//                           <div className="flex items-start gap-5">
//                             <div className="
//                               mt-1 w-6 h-6 rounded-full border border-white/20 
//                               flex items-center justify-center text-[10px] font-bold 
//                               text-white/40 group-hover:border-white group-hover:text-white 
//                               transition-all shrink-0
//                             ">
//                               {String.fromCharCode(65 + index)}
//                             </div>
//                             <span className="text-base lg:text-lg text-white/80 group-hover:text-white font-light leading-relaxed">
//                               {option}
//                             </span>
//                           </div>
//                         </button>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className="animate-in fade-in slide-in-from-bottom-4 duration-300">
//                       <GlassCard className={`
//                         p-8 border-l-4 
//                         ${isCorrect ? 'border-l-emerald-400 bg-emerald-500/10' : 'border-l-rose-500 bg-rose-500/10'}
//                       `}>
//                         <div className="flex items-center gap-3 mb-6">
//                           {isCorrect ? <CheckCircle2 className="text-emerald-400" size={28} /> : <XCircle className="text-rose-400" size={28} />}
//                           <span className={`text-2xl font-bold ${isCorrect ? 'text-emerald-100' : 'text-rose-100'}`}>
//                             {isCorrect ? 'Correct' : 'Incorrect'}
//                           </span>
//                         </div>

//                         <p className="text-lg text-white/80 leading-relaxed font-light mb-8">
//                           {currentQuestion.explanation}
//                         </p>

//                         <GlassButton 
//                           onClick={handleNextStep} 
//                           variant={isCorrect ? "primary" : "default"}
//                           className="w-full justify-between h-14 text-lg"
//                         >
//                           {isCorrect ? "Next Case" : "View Results"}
//                           <ArrowRight size={20} />
//                         </GlassButton>
//                       </GlassCard>
//                     </div>
//                   )}
//                 </div>
//               </div>
              
//             </div>
//           </div>
//         )}

//         {/* GAME OVER STATE */}
//         {gameState === 'gameover' && (
//           <GlassCard className="max-w-md w-full text-center p-8 md:p-12 animate-in zoom-in duration-300">
//             <span className="px-3 py-1 rounded-full border border-white/10 bg-white/5 text-[10px] font-bold uppercase tracking-widest text-white/40">
//               Session Terminated
//             </span>
//             <div className="mt-8 mb-2 text-8xl font-bold tracking-tighter text-white">
//               {score}
//             </div>
//             <div className="text-white/40 font-medium uppercase tracking-widest text-sm mb-10">
//               Final Score
//             </div>
//             <div className="space-y-3">
//               <GlassButton onClick={startGame} variant="primary" className="w-full h-12 text-lg">
//                 <RotateCcw size={20} /> Restart Protocol
//               </GlassButton>
//               <GlassButton onClick={shareScore} className="w-full h-12">
//                 <Share2 size={20} /> Share Analysis
//               </GlassButton>
//             </div>
//           </GlassCard>
//         )}
//       </div>
//     </div>
//   );
// }

// export default App;


import React, { useState, useEffect } from 'react';
import { Share2, Play, Info, ArrowRight, RotateCcw, XCircle, CheckCircle2, Zap } from 'lucide-react';
import questionsData from './questions';

const { questions } = questionsData;

// --- IMAGE LOADER ---
// Ensure 'src/touching-images' exists.
let touchingImages = [];
try {
  const r = require.context('./touching-images', false, /\.(png|jpe?g|svg|webp)$/);
  touchingImages = r.keys().map(r);
} catch (e) {
  console.log("Error loading images. Ensure 'src/touching-images' exists.");
}

// --- OPTIMIZED COMPONENT START ---
const BackgroundMontage = ({ touchingImages = [] }) => {
  // 1. CONSTANTS
  const DISPLAY_DURATION = 750; 
  const TRANSITION_DURATION = 125; 

  // 2. HOOKS (Must always run unconditionally)
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  // Helper to check validity inside hooks
  const hasImages = touchingImages && touchingImages.length > 0;

  // 3. JIT PRELOADING
  useEffect(() => {
    if (!hasImages) return;
    const nextIndex = (currentIndex + 1) % touchingImages.length;
    const img = new Image();
    img.src = touchingImages[nextIndex];
    
    // Optional: Preload buffer
    const nextNextIndex = (currentIndex + 2) % touchingImages.length;
    const img2 = new Image();
    img2.src = touchingImages[nextNextIndex];
  }, [currentIndex, hasImages, touchingImages]);

  // 4. INITIAL LOAD HANDLER
  useEffect(() => {
    if (!hasImages) return;
    const img = new Image();
    img.src = touchingImages[0];
    img.onload = () => setIsLoaded(true);
    img.onerror = () => setIsLoaded(true);
  }, [hasImages, touchingImages]);

  // 5. THE CLOCK
  useEffect(() => {
    if (!isLoaded || !hasImages) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % touchingImages.length);
    }, DISPLAY_DURATION);
    return () => clearInterval(interval);
  }, [isLoaded, hasImages, touchingImages, DISPLAY_DURATION]);

  // 6. EARLY RETURNS (Safe now because hooks are done)
  if (!hasImages) return null;
  if (!isLoaded) return null;

  // 7. PING-PONG RENDER LOGIC
  const activeIndex = currentIndex % 2; // 0 or 1
  const prevIndex = currentIndex === 0 ? touchingImages.length - 1 : currentIndex - 1;

  // Determine which image goes in Slot A vs Slot B
  const srcA = activeIndex === 0 ? touchingImages[currentIndex] : touchingImages[prevIndex];
  const srcB = activeIndex === 1 ? touchingImages[currentIndex] : touchingImages[prevIndex];

  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none bg-[#1e1e24] select-none">
      {/* Static Overlay */}
      <div className="absolute inset-0 bg-[#1e1e24]/60 z-20 backdrop-blur-[2px] will-change-transform" />

      {/* SLOT A: Handles Even Indices */}
      <img
        src={srcA}
        alt=""
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover will-change-opacity transition-opacity ease-in-out z-10"
        style={{
          transitionDuration: `${TRANSITION_DURATION}ms`,
          opacity: activeIndex === 0 ? 1 : 0,
          filter: 'saturate(200%)',
          transform: 'translate3d(0, 0, 0)', // Force GPU layer
        }}
      />

      {/* SLOT B: Handles Odd Indices */}
      <img
        src={srcB}
        alt=""
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover will-change-opacity transition-opacity ease-in-out z-10"
        style={{
          transitionDuration: `${TRANSITION_DURATION}ms`,
          opacity: activeIndex === 1 ? 1 : 0,
          filter: 'saturate(200%)',
          transform: 'translate3d(0, 0, 0)', // Force GPU layer
        }}
      />
    </div>
  );
};
// --- OPTIMIZED COMPONENT END ---


const GlassCard = ({ children, className = "" }) => (
  <div className={`
    relative backdrop-blur-2xl 
    bg-gradient-to-b from-white/10 to-white/5 
    border border-white/20 
    shadow-[0_8px_32px_0_rgba(0,0,0,0.36)] 
    rounded-3xl 
    ${className}
  `}>
    <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/20 pointer-events-none" />
    {children}
  </div>
);

const GlassButton = ({ onClick, children, className = "", variant = 'default' }) => {
  const variants = {
    default: "bg-white/5 hover:bg-white/10 border-white/10 text-white",
    primary: "bg-indigo-500 text-white hover:bg-indigo-400 border-transparent shadow-lg shadow-indigo-500/25 font-bold",
    danger: "bg-red-500/20 text-red-100 border-red-500/30 hover:bg-red-500/30"
  };

  return (
    <button
      onClick={onClick}
      className={`
        relative group overflow-hidden
        backdrop-blur-md border rounded-2xl p-4
        transition-all duration-300 ease-out
        active:scale-[0.98]
        font-medium tracking-wide
        flex items-center justify-center gap-3
        ${variants[variant]}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

function App() {
  const [gameState, setGameState] = useState('menu');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [showExplanation, setShowExplanation] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [usedQuestions, setUsedQuestions] = useState([]);
  const [highScore, setHighScore] = useState(0);

  useEffect(() => {
    const saved = localStorage.getItem('impossibleQuizHighScore');
    if (saved) setHighScore(parseInt(saved));
  }, []);

  function startGame() {
    const shuffled = [...questions].sort(() => Math.random() - 0.5);
    setUsedQuestions(shuffled);
    setCurrentQuestionIndex(0);
    setScore(0);
    setShowExplanation(false);
    setSelectedAnswer(null);
    setGameState('playing');
  }

  function handleAnswer(answerIndex) {
    const currentQ = usedQuestions[currentQuestionIndex];
    setSelectedAnswer(answerIndex);
    const correct = answerIndex === currentQ.correctAnswer;
    setIsCorrect(correct);
    setShowExplanation(true);
    if (correct) setScore(prev => prev + 10);
  }

  function handleNextStep() {
    if (isCorrect) {
      if (currentQuestionIndex + 1 < usedQuestions.length) {
        setCurrentQuestionIndex(prev => prev + 1);
        setShowExplanation(false);
        setSelectedAnswer(null);
      } else {
        endGame(score);
      }
    } else {
      endGame(score);
    }
  }

  function endGame(finalScore) {
    if (finalScore > highScore) {
      setHighScore(finalScore);
      localStorage.setItem('impossibleQuizHighScore', finalScore.toString());
    }
    setGameState('gameover');
  }

  function shareScore() {
    const text = `I scored ${score} points on the AI Spotter Assessment. 🧠`;
    const url = window.location.href;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
  }

  const currentQuestion = usedQuestions[currentQuestionIndex];
  const hasImages = currentQuestion?.images && currentQuestion.images.length > 0;
  const imageCount = hasImages ? currentQuestion.images.length : 0;

  return (
    <div className="min-h-screen bg-[#1e1e24] font-sans text-white overflow-x-hidden relative selection:bg-purple-500 selection:text-white">
      
      {/* Background Blobs (Behind Montage) */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-20%] left-[20%] w-[40vw] h-[40vw] bg-indigo-500/20 rounded-full blur-[100px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-indigo-500/10 rounded-full blur-[100px]" />
      </div>

      {/* Video Montage (Only in Menu) */}
      {gameState === 'menu' && <BackgroundMontage touchingImages={touchingImages} />}

      <div className="relative z-10 min-h-screen flex flex-col justify-center items-center p-4 md:p-6">

        {/* MENU STATE */}
        {gameState === 'menu' && (
          <div className="w-full max-w-md animate-in fade-in zoom-in duration-700">
            <div className="text-center mb-12 space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs font-medium uppercase tracking-widest text-white/50 backdrop-blur-sm">
                <Zap size={12} className="fill-white/50" />
                Pattern Recognition Test
              </div>
              <h1 className="text-6xl md:text-7xl font-bold tracking-tighter text-white" style={{ fontFamily: 'ui-monospace, monospace' }}>
                real or ai?
              </h1>
              <p className="text-white/60 text-lg" style={{ fontFamily: 'Georgia, serif' }}>
                humans leave fingerprints.<br />so do machines.
              </p>
            </div>
            
            <GlassCard className="p-2 space-y-2">
              <GlassButton onClick={startGame} variant="primary" className="w-full h-14 text-lg">
                <Play size={20} fill="currentColor" /> begin test
              </GlassButton>
              
              <GlassButton onClick={() => setGameState('instructions')} className="w-full h-14 text-lg text-white/70">
                <Info size={20} /> how it works
              </GlassButton>
            </GlassCard>

            {highScore > 0 && (
              <div className="mt-8 text-center animate-in fade-in slide-in-from-bottom-4 delay-200">
                  <span className="text-white/40 text-sm uppercase tracking-widest" style={{ fontFamily: 'ui-monospace, monospace' }}>
                    high_score: <span className="text-white ml-1">{highScore}</span>
                  </span>
              </div>
            )}
          </div>
        )}

        {/* INSTRUCTIONS STATE */}
        {gameState === 'instructions' && (
          <GlassCard className="max-w-xl w-full p-8 animate-in fade-in slide-in-from-bottom-8 duration-500">
            <h2 className="text-2xl font-bold mb-6 tracking-tight" style={{ fontFamily: 'ui-monospace, monospace' }}>HOW_IT_WORKS</h2>
            <div className="grid gap-4 mb-8">
              {[
                { icon: "01", text: "study the evidence carefully" },
                { icon: "02", text: "spot the tells, trust your gut" },
                { icon: "03", text: "correct = +10 pts" },
                { icon: "04", text: "wrong = game over" },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4 p-4 rounded-xl bg-white/5 border border-white/5">
                  <span className="text-xs font-mono text-white/40">{item.icon}</span>
                  <span className="text-base text-white/80" style={{ fontFamily: 'Georgia, serif' }}>{item.text}</span>
                </div>
              ))}
            </div>
            <GlassButton onClick={() => setGameState('menu')} className="w-full h-12">
              ← back
            </GlassButton>
          </GlassCard>
        )}

        {/* PLAYING STATE */}
        {gameState === 'playing' && currentQuestion && (
          <div className="w-full max-w-7xl mx-auto animate-in fade-in duration-500 pb-6">
            
            {/* Header Stats */}
            <div className="flex justify-between items-end mb-4 px-2">
              <div className="flex flex-col">
                <span className="text-[10px] text-white/40 uppercase tracking-widest mb-0.5" style={{ fontFamily: 'ui-monospace, monospace' }}>question</span>
                <span className="text-lg text-white/90" style={{ fontFamily: 'ui-monospace, monospace' }}>
                  {String(currentQuestionIndex + 1).padStart(2, '0')}<span className="text-white/30">/{usedQuestions.length}</span>
                </span>
              </div>
              <div className="flex flex-col items-end">
                  <span className="text-[10px] text-white/40 uppercase tracking-widest mb-0.5" style={{ fontFamily: 'ui-monospace, monospace' }}>pts</span>
                  <span className="text-lg font-mono text-white/90">{String(score).padStart(3, '0')}</span>
              </div>
            </div>

            {/* MAIN CONTENT GRID */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
              
              {/* LEFT COLUMN: THE PROMPT */}
              <div className="h-full">
                {hasImages ? (
                  <GlassCard className="relative overflow-hidden flex items-center justify-center bg-black/20 p-0 lg:h-[600px] min-h-[350px]">
                      <div className={`w-full h-full p-4 grid gap-4 ${imageCount > 1 ? 'grid-cols-2' : 'grid-cols-1'} items-center justify-items-center`}>
                      {currentQuestion.images.map((img, idx) => (
                        <div key={idx} className="relative w-full h-full flex items-center justify-center">
                            <img 
                              src={img} 
                              alt={`Subject ${idx+1}`}
                              className={`max-w-full h-auto rounded-lg shadow-2xl object-contain ${imageCount === 1 ? 'max-h-[450px]' : 'max-h-full'}`}
                            />
                            {imageCount > 1 && (
                              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-black/60 backdrop-blur-md rounded-full border border-white/10 text-[10px] font-bold text-white/80">
                                {idx === 0 ? 'IMAGE A' : 'IMAGE B'}
                              </div>
                            )}
                        </div>
                      ))}
                    </div>
                    <div className="absolute top-4 left-4 px-2 py-1 bg-black/50 backdrop-blur-md rounded border border-white/10 text-[10px] uppercase tracking-wider text-white/60 pointer-events-none">
                      Visual Evidence
                    </div>
                  </GlassCard>
                ) : (
                  <GlassCard className="h-full flex flex-col justify-center p-8 lg:p-12 min-h-[300px] lg:min-h-[600px]">
                    <div className="mb-6 inline-flex self-start px-3 py-1 rounded-full bg-white/10 border border-white/10 text-xs font-medium uppercase tracking-widest text-white/60">
                      {currentQuestion.category || "Text Analysis"}
                    </div>
                    <h3 className="text-3xl lg:text-5xl font-medium leading-tight text-white tracking-tight">
                      {currentQuestion.question}
                    </h3>
                    <div className="mt-8 flex items-center gap-3 text-white/40 text-sm">
                      <div className="h-[1px] w-12 bg-white/20"></div>
                      <span className="uppercase tracking-widest">Select the human response</span>
                    </div>
                  </GlassCard>
                )}
              </div>

              {/* RIGHT COLUMN: THE OPTIONS */}
              <div className="flex flex-col justify-center h-full">
                
                {hasImages && (
                  <div className="mb-6 px-2">
                      <h3 className="text-2xl lg:text-3xl font-medium text-white/95 leading-tight">
                        {currentQuestion.question}
                      </h3>
                  </div>
                )}

                <div className="space-y-3 w-full">
                  {!showExplanation ? (
                    <div className="grid grid-cols-1 gap-3">
                      {currentQuestion.options.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleAnswer(index)}
                          className="
                            group relative w-full text-left p-6 rounded-2xl
                            backdrop-blur-xl bg-white/5 border border-white/10
                            hover:bg-white/10 hover:border-white/20 hover:scale-[1.01]
                            active:scale-[0.99]
                            transition-all duration-200
                          "
                        >
                          <div className="flex items-start gap-5">
                            <div className="
                              mt-1 w-6 h-6 rounded-full border border-white/20 
                              flex items-center justify-center text-[10px] font-bold 
                              text-white/40 group-hover:border-white group-hover:text-white 
                              transition-all shrink-0
                            ">
                              {String.fromCharCode(65 + index)}
                            </div>
                            <span className="text-base lg:text-lg text-white/80 group-hover:text-white font-light leading-relaxed">
                              {option}
                            </span>
                          </div>
                        </button>
                      ))}
                    </div>
                  ) : (
                    <div className="animate-in fade-in slide-in-from-bottom-4 duration-300">
                      <GlassCard className={`
                        p-8 border-l-4 
                        ${isCorrect ? 'border-l-emerald-400 bg-emerald-500/10' : 'border-l-rose-500 bg-rose-500/10'}
                      `}>
                        <div className="flex items-center gap-3 mb-6">
                          {isCorrect ? <CheckCircle2 className="text-emerald-400" size={28} /> : <XCircle className="text-rose-400" size={28} />}
                          <span className={`text-2xl font-bold ${isCorrect ? 'text-emerald-100' : 'text-rose-100'}`}>
                            {isCorrect ? 'Correct' : 'Incorrect'}
                          </span>
                        </div>

                        <p className="text-lg text-white/80 leading-relaxed font-light mb-8">
                          {currentQuestion.explanation}
                        </p>

                        <GlassButton 
                          onClick={handleNextStep} 
                          variant={isCorrect ? "primary" : "default"}
                          className="w-full justify-between h-14 text-lg"
                        >
                          {isCorrect ? "Next Case" : "View Results"}
                          <ArrowRight size={20} />
                        </GlassButton>
                      </GlassCard>
                    </div>
                  )}
                </div>
              </div>
              
            </div>
          </div>
        )}

        {/* GAME OVER STATE */}
        {gameState === 'gameover' && (
          <GlassCard className="max-w-md w-full text-center p-8 md:p-12 animate-in zoom-in duration-300">
            <span className="px-3 py-1 rounded-full border border-white/10 bg-white/5 text-[10px] font-bold uppercase tracking-widest text-white/40">
              Session Terminated
            </span>
            <div className="mt-8 mb-2 text-8xl font-bold tracking-tighter text-white">
              {score}
            </div>
            <div className="text-white/40 font-medium uppercase tracking-widest text-sm mb-10">
              Final Score
            </div>
            <div className="space-y-3">
              <GlassButton onClick={startGame} variant="primary" className="w-full h-12 text-lg">
                <RotateCcw size={20} /> Restart Protocol
              </GlassButton>
              <GlassButton onClick={shareScore} className="w-full h-12">
                <Share2 size={20} /> Share Analysis
              </GlassButton>
            </div>
          </GlassCard>
        )}
      </div>
    </div>
  );
}

export default App;